import { Heading } from "@chakra-ui/react";

export default function SettingsHeader({ title }: { title: string }) {
  return (
    <Heading
      as="h4"
      color="black"
      fontWeight="600"
      fontSize="20px"
      lineHeight="28px"
    >
      {title}
    </Heading>
  );
}
